<template>
  <div v-if="dataType.indexOf('range') != -1">
固定值：按照“["{{formatStr()}}","{{formatStr()}}"]”格式填写；<br/>
动态值：“["now±n","now±n"]”表示当前时间，“["now±n","now±n"]”表示当前时间±n；<br/>
关联值：“${field}”表示指定字段值（注：字段值已存在），“${field}±n”表示指定字段值±n。
  </div>
  <div v-else>
固定值：按照“{{formatStr()}}”格式填写；<br/>
动态值：“now”表示当前时间，“now±n”表示当前时间±n；<br/>
关联值：“${field}”表示指定字段值（注：字段值已存在），“${field}±n”表示指定字段值±n。
  </div>
</template>

<script>
export default {
  props: ['dataType', 'isMaxMin'],
  data() {
    return {
      formatStr() {
        switch (this.dataType) {
          case 'year':
            return 'yyyy'
          case 'month':
            return 'yyyy-MM'
          case 'time':
            return 'HH:mm'
          case 'timerange':
            return 'HH:mm'
          default:
            return 'yyyy-MM-dd'
        }
      }
    }
  },
  watch: {
    // dataType: {
    //   handler(val) {
    //     console.log(val)
    //   },
    //   immediate: true
    // }
  }
}
</script>
